import { Box } from '@mui/material';
import Button from './Button';
import ButtonSecondary from './ButtonSecondary';
import ButtonLoader from './Loaders/ButtonLoader';

export default function StickyActionFooter({
    onCancel,
    onSave,
    cancelText = "Cancel",
    saveText = "Save",
    isLoading = false,
    disabled = false,
    showAddLocation = false,
    onAddLocation,
    showDelete = false,
    onDelete,
    deleteText = "Delete Location",
    className = "",
    style = {}
}) {
    return (
        <Box
            className={`border-t border-gray-200 ${className}`}
            sx={{
                
                backdropFilter: 'blur(8px)',
                borderTop: '1px solid #e5e7eb',
                padding: { xs: '12px 24px', sm: '16px 40px' },
                ...style
            }}
        >
            {/* ✅ MOBILE ONLY */}
            <Box sx={{ display: { xs: 'flex', sm: 'none' }, flexDirection: 'column', gap: 1.5 }}>

                {(onSave && saveText) && (
                    <Button
                        type="submit"
                        onClick={onSave}
                        className="w-full min-h-[36px]"
                        disabled={disabled || isLoading}
                    >
                        {isLoading ? <ButtonLoader /> : saveText}
                    </Button>
                )}

                {onCancel && (
                    <ButtonSecondary
                        onClick={onCancel}
                        disabled={isLoading}
                        className="w-full min-h-[36px]"
                    >
                        {cancelText}
                    </ButtonSecondary>
                )}

                {showAddLocation && (
                    <Box
                        onClick={onAddLocation}
                        sx={{
                            textAlign: 'center',
                            fontSize: '12px',
                            color: '#ff5f39',
                            cursor: 'pointer',
                            '&:hover': { textDecoration: 'underline' }
                        }}
                    >
                        + Add Another Service
                    </Box>
                )}

                {showDelete && (
                    <Box
                        onClick={onDelete}
                        sx={{
                            textAlign: 'center',
                            fontSize: '12px',
                            color: '#dc2626',
                            cursor: 'pointer',
                            '&:hover': { textDecoration: 'underline' }
                        }}
                    >
                        {deleteText}
                    </Box>
                )}
            </Box>

            {/* ✅ DESKTOP (RESTORED ORIGINAL CODE) */}
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                {showAddLocation ? (
                    <Box className="flex flex-col sm:flex-row justify-between items-center gap-4">
                        <Box
                            className="primary-link cursor-pointer"
                            onClick={onAddLocation}
                            style={{
                                color: '#ff5f39',
                                fontSize: '12px',
                                fontWeight: '400',
                                fontFamily: 'Poppins, sans-serif'
                            }}
                        >
                            + Add Another Service
                        </Box>
                        <Box className="flex items-center gap-4 justify-end">
                            {onCancel && (
                                <ButtonSecondary onClick={onCancel} disabled={isLoading}>
                                    {cancelText}
                                </ButtonSecondary>
                            )}
                            {(onSave && !!saveText) && (
                                <Button
                                    type="submit"
                                    onClick={onSave}
                                    className="flex items-center justify-center min-h-[40px]"
                                    disabled={disabled || isLoading}
                                    style={{ opacity: (disabled || isLoading) ? 0.5 : 1 }}
                                >
                                    {isLoading ? <ButtonLoader /> : saveText}
                                </Button>
                            )}
                        </Box>
                    </Box>
                ) : showDelete ? (
                    <Box className="flex flex-col sm:flex-row justify-between items-center gap-4">
                        <Box
                            className="cursor-pointer flex items-center gap-2"
                            onClick={onDelete}
                            style={{
                                color: '#dc2626',
                                fontSize: '12px',
                                fontWeight: '400',
                                fontFamily: 'Poppins, sans-serif'
                            }}
                        >
                            {deleteText}
                        </Box>
                        <Box className="flex items-center gap-4 justify-end">
                            {onCancel && (
                                <ButtonSecondary onClick={onCancel} disabled={isLoading}>
                                    {cancelText}
                                </ButtonSecondary>
                            )}
                            {(onSave && !!saveText) && (
                                <Button
                                    type="submit"
                                    onClick={onSave}
                                    className="flex items-center justify-center min-h-[40px]"
                                    disabled={disabled || isLoading}
                                    style={{ opacity: (disabled || isLoading) ? 0.5 : 1 }}
                                >
                                    {isLoading ? <ButtonLoader /> : saveText}
                                </Button>
                            )}
                        </Box>
                    </Box>
                ) : (
                    <Box className="flex items-center justify-end gap-4">
                        {onCancel && (
                            <ButtonSecondary onClick={onCancel} disabled={isLoading}>
                                {cancelText}
                            </ButtonSecondary>
                        )}
                        {(onSave && !!saveText) && (
                            <Button
                                type="submit"
                                onClick={onSave}
                                className="flex items-center justify-center min-h-[40px]"
                                disabled={disabled || isLoading}
                                style={{ opacity: (disabled || isLoading) ? 0.5 : 1 }}
                            >
                                {isLoading ? <ButtonLoader /> : saveText}
                            </Button>
                        )}
                    </Box>
                )}
            </Box>
        </Box>
    );
}